module.exports = __webpack_public_path__ + "static/media/limes-and-lemons.c2f65b0b.jpg";